
export class DebtAnalysisWidgetConfiguration {
  WidgetConfigurationId: number;
  GroupByField1: string;
  GroupByField2: string;
  View: string;
  Currency: string;
}
